module.exports =  require('./lib/mediaquery');

